import { useNavigate, useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Loader } from '@kep-ui-kit/ui-components';

import {
  CommonLayout,
  StyledContentContainer,
  StyledText,
  Delay,
} from '@selfserve/react-ui';

import { useEmailValidation } from '../data';
import { apiStatuses, routesPaths } from '@selfserve/react-utils';
import { useEffect } from 'react';

const StyledPleaseWaitText = styled(StyledText)(
  ({ theme }: { theme?: any }) => ({
    fontWeight: '600',
    marginBottom: '38px',
    maxWidth: '512px',
    fontSize: '32px',
    lineHeight: '42px',
  })
);
const StyledLoader = styled(Loader)(({ theme }: { theme?: any }) => ({
  width: '40px',
  height: '40px',
}));

export const PleaseWait = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const emailValidationData = useEmailValidation(id as string);
  const navigate = useNavigate();

  useEffect(() => {
    if(emailValidationData.data?.data?.subscriptionId)
      navigate(
        '../' + 
        routesPaths.CONFIRMED
          .replace(':subscriptionId', emailValidationData.data.data.subscriptionId as string)
      );

    if(emailValidationData.data?.status === apiStatuses.NOT_FOUND) {
      console.log(emailValidationData.data?.data?.status === apiStatuses.NOT_FOUND)

      navigate(
        '../' + 
        routesPaths.LINK_USED
      );
    }
    
  }, [emailValidationData]);

  return (
    <>
      <Helmet>
        <title>{t('titles.please-wait')}</title>
      </Helmet>
      <CommonLayout>
        <StyledContentContainer centered>
          <Delay animationDuration={0.5}>
            <StyledPleaseWaitText centered withMargin>
              {t('common.wait-few-seconds')}
            </StyledPleaseWaitText>
          </Delay>
          <StyledLoader size={'large'} />
        </StyledContentContainer>
      </CommonLayout>
    </>
  );
};
